module.exports = __webpack_public_path__ + "static/en-1-921e325aa3cd2a472561b4ed0c8f743d.png";